/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { useAppCoffeeMugContext } from "../../../../Basis/Components/AppCoffeeMugContext";
import { useAppDownloadContext } from "../../../../Basis/Components/AppDownloadContext";
import { DownloadIcon } from "../../../../Basis/FontAwesome";
import IconLink from "../../../../Cloud/Buchungsportal/Components/IconLink";
import VertragZurNutzungDerSaaSLoesungClient from "../../Api/VertragZurNutzungDerSaaSLoesungClient";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nMandanten";

export default function VertragZurNutzungDerSaaSLoesungDownloadLink() {
    const { t } = useTranslation();
    const appDownloadContext = useAppDownloadContext();
    const vertragZurNutzungDerSaaSLoesungClient = new VertragZurNutzungDerSaaSLoesungClient();
    const appCoffeeMugContext = useAppCoffeeMugContext();

    return (
        <IconLink
            sx={{ color: "secondary.main", marginBottom: ".3rem" }}
            onClick={() => {
                appCoffeeMugContext.show(t(translationKeys.vertragZurNutzungDerSaaSLoesungDownloadLink.vertragWirdHeruntergeladen));
                vertragZurNutzungDerSaaSLoesungClient.stelleSicher()
                    .then((datei) => {
                        const url = window.URL.createObjectURL(datei);
                        appDownloadContext.ladeHerunter(url, datei.name);
                    })
                    .finally(() => {
                        appCoffeeMugContext.hide();
                    });
            }}
            icon={<DownloadIcon />}>
            {t(translationKeys.vertragZurNutzungDerSaaSLoesungDownloadLink.vertragZurNutzungDerSaaSLoesung)}
        </IconLink>
    );
}
